import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './config';

export const supabaseInitError: string | null =
  !SUPABASE_URL || !SUPABASE_ANON_KEY
    ? 'Missing Supabase environment variables (VITE_SUPABASE_URL, VITE_SUPABASE_PUBLISHABLE_KEY). Check your Vercel project settings.'
    : null;

if (supabaseInitError) {
  console.error(supabaseInitError);
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = (
  SUPABASE_URL && SUPABASE_ANON_KEY
    ? createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: (url: RequestInfo | URL, options?: RequestInit) => {
      const headers = new Headers(options?.headers);
      if (typeof window !== 'undefined') {
        headers.set('x-client-route', window.location.pathname);
      }
      // Generate correlation ID for edge function calls to enable distributed tracing
      const urlStr = typeof url === 'string' ? url : url instanceof URL ? url.href : url.url;
      if (urlStr?.includes('/functions/v1/')) {
        headers.set('x-correlation-id', crypto.randomUUID().substring(0, 8));
      }
      return fetch(url, { ...options, headers });
    },
  },
})
    : null
) as SupabaseClient<Database>;

// Issue #845: expose the singleton on `window` in DEV mode so the Playwright
// impersonate helper (e2e/app/helpers/impersonate.ts) can call
// `supabase.auth.verifyOtp` from inside `page.evaluate`. Vite tree-shakes the
// `import.meta.env.DEV` branch out of production builds.
if (import.meta.env.DEV && typeof window !== 'undefined') {
  (window as Window & { supabase?: SupabaseClient<Database> }).supabase = supabase;
}